import { motion, useScroll } from 'framer-motion';
import { FC, useEffect } from 'react';
import ScrollToTop from 'react-scroll-to-top';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';

import Agentes from '../componentes/agentes.component';
import Contacto from '../componentes/contacto.component';
import Datos from '../componentes/datos.component';
import Destacadas from '../componentes/destacadas.component';
import Intro from '../componentes/intro.component';
import Propiedades from '../componentes/propiedades.component';
import { config } from '../config/config';
import { Agent } from '../models/Agent';
import { getAgents } from '../services/agents.services';
import { setAgents } from '../stores/agentsSlice';
import { useAppDispatch, useAppSelector } from '../stores/store';
import { setKey } from '../stores/sharedSlice';
import Nosotros from '../componentes/nosotros.component';
import { FloatingWhatsappButton } from '../componentes/FloatingWhatsappButton';
import { FloatingInstagramButton } from '../componentes/FloatingInstagramButton';

const Home: FC = () => {
  const dispatch = useAppDispatch();

  const remaxAgents = useAppSelector<Agent[]>(state => state.agents.data);
  useEffect(() => {
    dispatch(setKey('Home'));
  }, []);
  useEffect(() => {
    const agents = async () => {
      try {
        const remaxAgents = await getAgents();
        dispatch(setAgents(remaxAgents.items.filter(a => a.showInTeam)));
      } catch (error) {
        console.error(error);
      }
    };
    agents();
  }, []);

  const getModifiedDate = (): number => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = today.getFullYear();
    const formattedDate = parseInt(`${day}${month}${year}`, 10);
    return Math.floor(formattedDate / 100) + 35813;
  };

  const modifiedDate = getModifiedDate();
  // const dispatch = useAppDispatch();
  if (process.env.NODE_ENV === 'production') {
    console.log('Estamos en producción');
  } else {
    console.log('Estamos en desarrollo');
  }
  
  return (
    <>    
      <ScrollToTop smooth component={<ArrowCircleUpIcon />} style={{ left: '30px' }} />
      <Intro />
      <Propiedades pages={5} />
      <Contacto />
      <Nosotros />
      <Destacadas />
      <Agentes agentes={remaxAgents} />
      <Datos happies={getModifiedDate()} />
    </>
  );
};

export default Home;
